import axios from "../../../axios"


export const GetClientTickets = async (email) => {
  return axios.post("api/Client/tickets", { email });
};

export const GetProjectData = async (email) => {
  return axios.post("/api/Client/ProjectData", { email });
};

export const CreateExternalTicket = (data) => {
  return axios.post(
    "/api/ExternalTicket/CreateExternalTicket",
    data,
    {
      headers: {
        "X-Public-Request": true,
        "Content-Type": "multipart/form-data",
      },
    }
  );
};